import { memo } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { LOADER_HEIGHT, LOADER_WIDTH, LOADERS_COUNT } from "app/pages/activation/components/Topics/Modal/constants";

import { suggestedLoaderKeys } from "../automationKeys";

import * as SC from "./styles";

export const SuggestedLoader = memo(() =>
    Array.from({ length: LOADERS_COUNT }).map((_, i) => (
        <SC.ItemContainer
            data-automation={suggestedLoaderKeys.item}
            key={i}
        >
            <PixelPlaceholderLoader
                height={LOADER_HEIGHT}
                width={LOADER_WIDTH}
            />
        </SC.ItemContainer>
    )),
);

SuggestedLoader.displayName = "SuggestedLoader";
